import React from 'react';

function UrineRoutineForm() {
  return (
    <div>
      <h2>UrineRoutineForm</h2>
    </div>
  );
}

export default UrineRoutineForm;
